/* eslint-disable react/prop-types */
import React from 'react';
import ParticipationRate from '../ParticipationRate';

/**
 * Headline metric cards (026 US1 + US5) on the shared au-card design system.
 * Users who paused / meditation users / breathing users — each with its
 * feature-024 participation rate and a period-over-period delta (text + icon,
 * never colour alone).
 */
const ICONS = { up: '▲', down: '▼', flat: '→', new: '★' };
const DELTA_CLASS = { up: 'au-delta--up', down: 'au-delta--down', flat: 'au-delta--flat', new: 'au-delta--flat' };

const Delta = ({ delta }) => {
  if (!delta) return null;
  const { direction, delta_pct: pct } = delta;
  const pill = direction === 'new'
    ? `${ICONS.new} New`
    : direction === 'flat'
      ? `${ICONS.flat} 0%`
      : `${ICONS[direction]} ${Math.abs(pct)}%`;
  const label = direction === 'new' ? 'this period' : 'vs prior period';
  return (
    <span className="pause-delta" aria-label={`${pill} ${label}`}>
      <span className={`au-delta ${DELTA_CLASS[direction]}`}>{pill}</span>
      <span className="pause-delta__lbl">{label}</span>
    </span>
  );
};

const Card = ({ label, value, base, delta }) => (
  <div className="au-card">
    <span className="au-card__label">{label}</span>
    <span className="au-card__value tnum">{Number(value || 0).toLocaleString()}</span>
    <ParticipationRate className="au-card__sub" count={value} total={base} />
    <Delta delta={delta} />
  </div>
);

const PauseSummaryCards = ({ totalUserBase = 0, pausedUsers = 0, splitCounts = {}, deltas = {} }) => (
  <div className="au-cards" data-testid="pause-summary">
    <Card label="Users who paused" value={pausedUsers} base={totalUserBase} delta={deltas.paused_users} />
    <Card label="Meditation users" value={splitCounts.meditation_user_count} base={totalUserBase} delta={deltas.meditation_users} />
    <Card label="Breathing users" value={splitCounts.breath_user_count} base={totalUserBase} delta={deltas.breathing_users} />
  </div>
);

export default PauseSummaryCards;
